import type { FunctionComponent, PropsWithChildren } from 'react';
import classNames from 'classnames';
import * as styles from './PageContainer.module.css';

type PageContainerProps = {
  className?: string;
};

const PageContainer: FunctionComponent<PropsWithChildren<PageContainerProps>> = ({
  className = null,
  children,
}) => <div className={classNames(styles.container, className)}>{children}</div>;

export default PageContainer;
